module.exports = __webpack_public_path__ + "static/img/donation_collabor_logo.4da31eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/donation_collabor_logo.svg
// module id = 6REB
// module chunks = 1